import React from 'react';
import Card from 'material-ui/Card';
import CardActions from 'material-ui/Card/CardActions';
import CardContent from 'material-ui/Card/CardContent';
import Button from 'material-ui/Button';
import Typography from 'material-ui/Typography';
import {connect} from "react-redux";
import {setSend, setGotResponse, expectResult, gotError} from "../actions/process";
import serverRequest from '../service/serverRequest';
import {gotUserSessions} from "../actions/data";
import {setKey} from "../actions/filters";
import {decodeParse} from "../service/b64utf16";

const Session=(props)=> {
    const { item, filters, dispatch, user } = props;
    return (
        <div>
            <Card className='session card'>
                <CardContent>
                    <Typography className='session title' color="textSecondary">
                        {item.products ? item.products.join(", ") : ''}
                    </Typography>
                    {   item.version ?
                        <Typography className='session pos' color="textSecondary">
                            {item.version}
                        </Typography> : null
                    }
                    <Typography variant="headline" component="h2">
                        {item.usernames}
                    </Typography>
                    <Typography className='session pos' color="textSecondary">
                        {item.id}
                    </Typography>
                    <Typography component="p">
                        {item.editor ?'editor':''}
                    </Typography>
                </CardContent>
                <CardActions>
                    <Button size="small" onClick={()=>{
                        dispatch(expectResult('USER_SESSIONS'));
                        dispatch(setSend());
                        dispatch(setKey(item.key));
                        filters.key=item.key;
                        filters.path='/raw';
                        serverRequest(filters, (status,responseText)=>{
 //                           console.log(responseText);
                            dispatch(gotUserSessions(decodeParse(responseText)));
                            dispatch(setGotResponse('USER_SESSIONS'))
                        },error=>{
                            console.log(error);
                            dispatch(gotError(error))
                        },user)
                    }}>Детализация</Button>
                </CardActions>
            </Card>
        </div>
    );
};

const mapStateToProps=(state)=>({filters:state.filters, user : state.user});
const ConnectedSession=connect(mapStateToProps)(Session);
export default ConnectedSession;